import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const PolitiqueCookies = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Simple Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Link to="/" className="text-teal-600 hover:text-teal-700 font-semibold flex items-center cursor-pointer whitespace-nowrap">
            <i className="ri-arrow-left-line mr-2"></i>
            Retour à l'accueil
          </Link>
        </div>
      </header>

      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 text-center">
              Politique de <strong className="text-teal-600">Cookies</strong>
            </h1>
            
            <div className="bg-white rounded-lg p-8 space-y-8 shadow-lg">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">1. Qu'est-ce qu'un cookie ?</h3>
                <p className="text-gray-700 leading-relaxed">
                  Un cookie est un petit fichier texte déposé sur votre terminal (ordinateur, smartphone, tablette) lors de la visite d'un site web. Il permet de collecter des informations relatives à votre navigation et de vous proposer des services adaptés.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">2. Types de cookies utilisés</h3>
                
                <div className="space-y-6">
                  <div className="bg-gray-50 rounded-lg p-6">
                    <h4 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                      <i className="ri-shield-check-line text-teal-600 mr-2"></i>
                      Cookies strictement nécessaires
                    </h4>
                    <p className="text-gray-700 leading-relaxed mb-3">
                      Ces cookies sont indispensables au fonctionnement du site. Ils ne peuvent pas être désactivés.
                    </p>
                    <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                      <li><strong>Cookie de session :</strong> maintient votre session active</li>
                      <li><strong>Cookie de sécurité :</strong> protège contre les attaques CSRF</li>
                      <li><strong>Cookie de consentement :</strong> mémorise vos choix de cookies</li>
                    </ul>
                    <p className="text-sm text-gray-600 mt-3">
                      <strong>Durée :</strong> Session ou 13 mois maximum
                    </p>
                  </div>

                  <div className="bg-gray-50 rounded-lg p-6">
                    <h4 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                      <i className="ri-bar-chart-line text-teal-600 mr-2"></i>
                      Cookies analytiques
                    </h4>
                    <p className="text-gray-700 leading-relaxed mb-3">
                      Ces cookies nous permettent de mesurer l'audience du site et d'améliorer son contenu.
                    </p>
                    <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                      <li><strong>Google Analytics :</strong> statistiques de visite anonymisées</li>
                      <li><strong>Nombre de visiteurs :</strong> comptabilisation des visites</li>
                      <li><strong>Pages consultées :</strong> analyse du parcours utilisateur</li>
                    </ul>
                    <p className="text-sm text-gray-600 mt-3">
                      <strong>Durée :</strong> 13 mois maximum
                    </p>
                    <p className="text-sm text-teal-600 mt-2">
                      ✓ Nécessite votre consentement
                    </p>
                  </div>

                  <div className="bg-gray-50 rounded-lg p-6">
                    <h4 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                      <i className="ri-settings-3-line text-teal-600 mr-2"></i>
                      Cookies fonctionnels
                    </h4>
                    <p className="text-gray-700 leading-relaxed mb-3">
                      Ces cookies améliorent votre expérience en mémorisant vos préférences.
                    </p>
                    <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                      <li><strong>Préférences de langue :</strong> mémorise votre langue</li>
                      <li><strong>Paramètres d'affichage :</strong> mémorise vos choix d'interface</li>
                      <li><strong>Formulaires :</strong> pré-remplit certains champs</li>
                    </ul>
                    <p className="text-sm text-gray-600 mt-3">
                      <strong>Durée :</strong> 12 mois maximum
                    </p>
                    <p className="text-sm text-teal-600 mt-2">
                      ✓ Nécessite votre consentement
                    </p>
                  </div>

                  <div className="bg-gray-50 rounded-lg p-6">
                    <h4 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                      <i className="ri-chat-3-line text-teal-600 mr-2"></i>
                      Cookies de l'assistant IA
                    </h4>
                    <p className="text-gray-700 leading-relaxed mb-3">
                      Ces cookies permettent le fonctionnement de l'assistant vocal et chat.
                    </p>
                    <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                      <li><strong>Session de conversation :</strong> maintient le contexte du chat</li>
                      <li><strong>Préférences vocales :</strong> mémorise vos paramètres audio</li>
                    </ul>
                    <p className="text-sm text-gray-600 mt-3">
                      <strong>Durée :</strong> Session
                    </p>
                    <p className="text-sm text-teal-600 mt-2">
                      ✓ Nécessite votre consentement
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">3. Gestion de vos cookies</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Vous pouvez à tout moment modifier vos préférences de cookies :
                </p>
                
                <div className="bg-teal-50 border-l-4 border-teal-600 p-6 mb-6">
                  <h4 className="text-xl font-bold text-gray-900 mb-3">Via notre bandeau de consentement</h4>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Lors de votre première visite, un bandeau vous permet d'accepter ou de refuser les cookies non essentiels.
                  </p>
                  <button
                    onClick={() => {
                      localStorage.removeItem('cookieConsent');
                      window.location.reload();
                    }}
                    className="bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-all cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-settings-3-line mr-2"></i>
                    Gérer mes préférences
                  </button>
                </div>

                <div className="space-y-4">
                  <h4 className="text-xl font-bold text-gray-900">Via votre navigateur</h4>
                  <p className="text-gray-700 leading-relaxed mb-3">
                    Vous pouvez également configurer votre navigateur pour accepter ou refuser les cookies :
                  </p>
                  <ul className="space-y-3 text-gray-700">
                    <li className="flex items-start">
                      <i className="ri-chrome-line text-teal-600 mr-3 mt-1"></i>
                      <div>
                        <strong>Google Chrome :</strong> Paramètres &gt; Confidentialité et sécurité &gt; Cookies
                        <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:underline ml-2 cursor-pointer">En savoir plus</a>
                      </div>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-firefox-line text-teal-600 mr-3 mt-1"></i>
                      <div>
                        <strong>Mozilla Firefox :</strong> Options &gt; Vie privée et sécurité &gt; Cookies
                        <a href="https://support.mozilla.org/fr/kb/cookies" target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:underline ml-2 cursor-pointer">En savoir plus</a>
                      </div>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-safari-line text-teal-600 mr-3 mt-1"></i>
                      <div>
                        <strong>Safari :</strong> Préférences &gt; Confidentialité &gt; Cookies
                        <a href="https://support.apple.com/fr-fr/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:underline ml-2 cursor-pointer">En savoir plus</a>
                      </div>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-edge-line text-teal-600 mr-3 mt-1"></i>
                      <div>
                        <strong>Microsoft Edge :</strong> Paramètres &gt; Confidentialité &gt; Cookies
                        <a href="https://support.microsoft.com/fr-fr/microsoft-edge/supprimer-les-cookies-dans-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:underline ml-2 cursor-pointer">En savoir plus</a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">4. Conséquences du refus des cookies</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Le refus des cookies peut avoir les conséquences suivantes :
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Impossibilité d'utiliser certaines fonctionnalités du site</li>
                  <li>Perte de vos préférences à chaque visite</li>
                  <li>Expérience utilisateur dégradée</li>
                  <li>Impossibilité d'utiliser l'assistant IA</li>
                </ul>
                <p className="text-gray-700 leading-relaxed mt-4">
                  <strong>Note :</strong> Les cookies strictement nécessaires ne peuvent pas être refusés car ils sont indispensables au fonctionnement du site.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">5. Durée de conservation</h3>
                <p className="text-gray-700 leading-relaxed">
                  Les cookies sont conservés pour une durée maximale de <strong>13 mois</strong> conformément aux recommandations de la CNIL. Votre consentement est redemandé tous les 13 mois.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">6. Cookies tiers</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Certains cookies sont déposés par des services tiers :
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li><strong>Google Analytics :</strong> mesure d'audience (données anonymisées)</li>
                  <li><strong>Readdy Agent :</strong> assistant IA conversationnel</li>
                </ul>
                <p className="text-gray-700 leading-relaxed mt-4">
                  Ces services ont leurs propres politiques de confidentialité que nous vous invitons à consulter.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">7. Modifications</h3>
                <p className="text-gray-700 leading-relaxed">
                  Nous nous réservons le droit de modifier cette politique de cookies à tout moment. Date de dernière mise à jour : <strong>20/11/2025</strong>
                </p>
              </div>

              <div className="bg-teal-50 border-l-4 border-teal-600 p-6 mt-8">
                <h4 className="text-xl font-bold text-gray-900 mb-3">Contact</h4>
                <p className="text-gray-700 leading-relaxed mb-2">
                  Pour toute question relative aux cookies :
                </p>
                <p className="text-gray-700 leading-relaxed">
                  <strong>Email :</strong> info@dfpro.fr<br />
                  <strong>Téléphone :</strong> 04.65.84.88.50
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default PolitiqueCookies;
